import { Checkbox, FormControlLabel } from "@mui/material";
import React from "react";
import { FiEdit, FiTrash } from "react-icons/fi";
import { deleteReminder } from "../../services/ReminderService";
import { showToastError, showToastSuccess } from "../../Utils/Helper";
import { toastMsg } from "../../Utils/AllConstant";

function Taskchip({ type,label, priority, isChecked, onClick, onEdit, getReminders,id }) {

  const deleteRemind = async (id) => {
    try {
      const response = await deleteReminder(id);
      if (response.status === 200) {
        showToastSuccess('Reminder Removed')
        getReminders()
      } else {
        showToastError(response?.data || response.message || toastMsg.errorMssg)
      }
    } catch (error) {
      showToastError(error?.data?.data || error.data?.message || toastMsg.errorMssg)
    }
  };
  return (
    
    <div
      style={{ height: "auto" }}
      className="shadow rounded-4 mb-3 px-3 py-2 "
      key={id}
    >
      <p
        style={{ fontSize: "12px", color: "rgba(126, 124, 124, 1)" }}
        className="fw-bold m-0"
      >
        {type === 'reminder' ? "Reminder" : "Tasks"}
      </p>
      <div className="d-flex justify-content-between align-items-center resFont">
        <FormControlLabel
          control={<Checkbox color="success" checked={isChecked} onChange={onClick}/>}
          label={label}
        />
        <div>
          {priority && (
            <div
              className="fw-semibold d-flex gap-2 align-items-center resFont mb-1"
            >
              <div
                style={{
                  height: "10px",
                  width: "10px",
                  borderRadius: "50%",
                  backgroundColor:
                    priority === "High"
                      ? "rgba(216, 16, 16, 1)"
                      : "rgba(255, 210, 51, 1)",
                }}
              ></div>
              <span>{priority} Priority</span>
            </div>
          )}
          {!isChecked && (
            <div className="d-flex justify-content-end gap-2">
              <button
                className="btn px-1 py-0"
                style={{ backgroundColor: "rgba(227, 236, 237, 1)" }}
                onClick={()=>onEdit(type, true)}
              >
                <FiEdit />
              </button>
              <button
                className="btn px-1 py-0"
                style={{ backgroundColor: "rgba(227, 236, 237, 1)" }}
                onClick={()=>deleteRemind(id)}
              >
                <FiTrash />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Taskchip;
